// extracted by mini-css-extract-plugin
module.exports = {"secure":"_e282899","logo":"_3bc8430"};